var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoFull = function SvgLogoFull(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 114 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-full_svg__a)",
    d: "M34.543.546a1.85 1.85 0 0 0-2.626 0 1.867 1.867 0 0 0 0 2.635l4.968 4.984 1.168-1.172a2.074 2.074 0 0 0 0-2.926z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-full_svg__b)",
    d: "m30.044 2.784 9.705 9.89-2.677 2.728-9.705-9.89z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-full_svg__c)",
    d: "m30.048 9.835 4.97 4.883a1.97 1.97 0 0 1 0 2.719c-.724.75-1.898.75-2.623 0l-3.514-3.681c-.804-.834-.804-1.878 0-2.712z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-full_svg__d)",
    d: "M41.764 7.429a1.755 1.755 0 0 0-2.575 0c-.711.75-.711 1.967 0 2.717l1.287 1.36 1.288-1.36a2 2 0 0 0 0-2.717"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-full_svg__e)",
    d: "m26.82 6.495 1.288 1.359c.712.75.712 1.967 0 2.717-.71.75-1.864.75-2.575 0a2 2 0 0 1 0-2.717z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-full_svg__f)",
    d: "M77.597.52 46.988 4.705c-.447 0-.877.186-1.193.515-.316.33-.494.776-.494 1.242l-.208 6.157c0 .97.757 1.183 1.687 1.183l8.74-1.16-.14 4.21c0 .508.352.628.787.628l14.168-1.872c.437 0 .788-.42.788-.934l.089-4.117 5.805-.772a1.66 1.66 0 0 0 1.191-.518c.316-.33.492-.777.491-1.243l.3-6.037c.007-.97-.462-1.467-1.402-1.467m.52 7.53a1 1 0 0 1-.276.688.92.92 0 0 1-.663.285l-6.362.885q.003.045 0 .09l-.22 4.485c0 .156-.06.306-.166.416a.56.56 0 0 1-.4.173l-13.523 1.833a.55.55 0 0 1-.4-.173.6.6 0 0 1-.166-.416l.057-3.274a.6.6 0 0 1 .165-.42.57.57 0 0 1 .402-.173l9.858-1.73-19.81 2.563a.92.92 0 0 1-.662-.286 1 1 0 0 1-.275-.69l.163-6.025c0-.259.099-.507.275-.69a.92.92 0 0 1 .663-.285l30.755-4.088q.186 0 .358.074.172.073.305.21a.98.98 0 0 1 .274.69z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m48.642 11.58.427-5.565 1.043-.133L51.5 8.397l1.83-2.925.997-.127-.428 5.565-1.119.143.147-1.908q.038-.486.084-.9a14 14 0 0 1 .115-.803L51.62 9.783l-.502.064-1.143-1.987q.002.36-.014.765-.016.403-.054.904l-.147 1.909zM54.652 10.814l2.513-5.83 1.02-.13 1.648 5.3-1.171.15-.329-1.116-2.039.26-.516 1.223zm2.428-3.253-.37.881 1.355-.172-.245-.827a17 17 0 0 1-.136-.495l-.142-.596q-.106.306-.229.62-.122.315-.233.589M62.869 9.846q-.624.08-1.117-.07a2.05 2.05 0 0 1-.836-.5 2.1 2.1 0 0 1-.508-.84 2.9 2.9 0 0 1-.11-1.112q.047-.612.292-1.155.254-.552.663-.982.419-.44.952-.72.535-.28 1.15-.359a2.46 2.46 0 0 1 1.167.111q.528.184.817.55l-.768.869a1.8 1.8 0 0 0-.596-.38 1.44 1.44 0 0 0-.71-.076q-.471.06-.87.347-.39.279-.643.712a2.1 2.1 0 0 0-.29.934q-.039.502.158.886.197.376.567.565.37.19.849.128.343-.043.634-.215.293-.178.478-.438a1.07 1.07 0 0 0 .208-.546l-1.37.174.077-.994 2.465-.314q.004.133-.003.34-.001.204-.01.315a2.9 2.9 0 0 1-.425 1.322 3.15 3.15 0 0 1-.942.978q-.578.38-1.28.47M66.137 9.351l.078-1.026.89-.113.27-3.514-.89.113.08-1.025 2.92-.373-.078 1.026-.89.113-.27 3.515.89-.114-.079 1.026zM72.525 8.616q-.783.099-1.364-.189a1.93 1.93 0 0 1-.873-.896q-.292-.61-.227-1.451.047-.612.292-1.155.246-.551.648-.98.402-.437.921-.716a3.2 3.2 0 0 1 1.105-.353q.57-.073 1.076.106.515.17.809.559l-.779.918a1.5 1.5 0 0 0-.543-.38 1.2 1.2 0 0 0-.657-.081q-.435.054-.809.323a2.1 2.1 0 0 0-.617.685 2.15 2.15 0 0 0-.283.933q-.04.533.135.896.183.363.539.53.364.166.866.102.365-.045.696-.238.34-.2.588-.484l.49.858a2.6 2.6 0 0 1-.531.454 3.8 3.8 0 0 1-.714.366q-.38.144-.768.193M57.766 15.573a.94.94 0 0 1-.494-.055.8.8 0 0 1-.339-.292l.295-.346q.134.206.275.273a.6.6 0 0 0 .326.046.6.6 0 0 0 .277-.104.29.29 0 0 0 .13-.21.21.21 0 0 0-.11-.211.8.8 0 0 0-.343-.09q-.676-.063-.628-.627a.7.7 0 0 1 .133-.354 1 1 0 0 1 .304-.27q.186-.105.404-.131a.87.87 0 0 1 .46.05.55.55 0 0 1 .279.259l-.295.31q-.168-.281-.477-.245a.54.54 0 0 0-.277.107.29.29 0 0 0-.12.21q-.012.13.088.193.105.063.31.084.34.031.524.175.188.144.164.406a.84.84 0 0 1-.137.4.9.9 0 0 1-.308.286 1.2 1.2 0 0 1-.441.136M59.989 15.311a1 1 0 0 1-.43-.037.8.8 0 0 1-.33-.204.9.9 0 0 1-.198-.35 1.2 1.2 0 0 1-.04-.463 1.5 1.5 0 0 1 .384-.883q.165-.18.374-.291.209-.113.445-.14a1 1 0 0 1 .433.036.8.8 0 0 1 .327.209.9.9 0 0 1 .197.35q.063.204.041.46a1.5 1.5 0 0 1-.145.526q-.117.245-.304.422l.232.34-.329.273-.255-.367a1.2 1.2 0 0 1-.402.12m.035-.407a.7.7 0 0 0 .143-.033l-.257-.372.337-.26.277.395a.9.9 0 0 0 .172-.263q.066-.154.081-.325a.75.75 0 0 0-.057-.386.5.5 0 0 0-.218-.25.55.55 0 0 0-.343-.06.75.75 0 0 0-.361.143.9.9 0 0 0-.267.304 1 1 0 0 0-.122.41.8.8 0 0 0 .053.393.52.52 0 0 0 .218.248.56.56 0 0 0 .344.056M62.415 15.013a.83.83 0 0 1-.456-.06.65.65 0 0 1-.296-.284.8.8 0 0 1-.076-.452l.122-1.417.412-.049-.12 1.388q-.012.15.043.264.06.114.162.173.107.059.243.043a.6.6 0 0 0 .267-.103.69.69 0 0 0 .292-.495l.12-1.388.396-.047-.123 1.417a1.1 1.1 0 0 1-.16.48 1.105 1.105 0 0 1-.827.53M63.585 14.855l1.058-2.397.383-.045.654 2.196-.424.05-.144-.503-.88.104-.238.547zm.993-1.4-.182.418.613-.072-.112-.393-.033-.119-.041-.177-.04-.177-.106.275q-.056.143-.099.246M66.027 14.568l.199-2.297.956-.113a.6.6 0 0 1 .35.053q.156.076.239.232a.63.63 0 0 1 .065.363.84.84 0 0 1-.15.407.96.96 0 0 1-.325.298l.427.852-.484.054-.38-.79-.425.05-.072.844zm.505-1.261.56-.066a.34.34 0 0 0 .225-.124.43.43 0 0 0 .106-.253q.014-.157-.082-.244-.095-.09-.261-.07l-.488.058zM68.22 14.31l.199-2.297 1.44-.17-.033.387-1.035.122-.047.545.874-.103-.033.38-.874.103-.052.598 1.048-.124-.034.387z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-full_svg__a",
    x1: 37.336,
    x2: 28.117,
    y1: 3.339,
    y2: 13.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F170A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    stopColor: "#D561CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EBFFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-full_svg__b",
    x1: 37.335,
    x2: 28.117,
    y1: 3.339,
    y2: 13.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F170A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    stopColor: "#D561CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EBFFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-full_svg__c",
    x1: 37.336,
    x2: 28.118,
    y1: 3.339,
    y2: 13.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F170A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    stopColor: "#D561CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EBFFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-full_svg__d",
    x1: 37.335,
    x2: 28.116,
    y1: 3.339,
    y2: 13.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F170A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    stopColor: "#D561CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EBFFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-full_svg__e",
    x1: 37.336,
    x2: 28.118,
    y1: 3.339,
    y2: 13.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F170A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    stopColor: "#D561CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EBFFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-full_svg__f",
    x1: 45.093,
    x2: 79.006,
    y1: 8.997,
    y2: 8.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F170A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#D561CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EBFFA"
  })))));
};
export { SvgLogoFull as ReactComponent };